import SectionLabel from "./SectionLabel";
import { FadeUp, MaskLine } from "./Reveal";

const traits = [
  "Leads and still knows she needs wisdom.",
  "Builds but refuses to build without Heaven.",
  "Carries responsibility and understands the value of perspective.",
  "Is standing at the edge of a decision, transition, opportunity, or new season.",
  "Is tired of surface-level networking.",
  "Values meaningful relationships.",
  "Knows that sometimes the wisest thing you can do is pause before you move.",
  "Has something to contribute — not just something to receive.",
];

export default function WhoFor() {
  return (
    <section data-testid="who-for-section" className="border-b border-ink/15">
      <div className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-40">
        <SectionLabel testid="who-for-label">Who This Gathering Is For</SectionLabel>

        <h2 className="max-w-3xl font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
          <MaskLine>This is for the woman</MaskLine>
          <MaskLine delay={0.1}>
            who <span className="italic text-wine">carries weight.</span>
          </MaskLine>
        </h2>

        <div className="mt-16 md:ml-auto md:max-w-3xl">
          <p className="mb-4 font-sans text-[11px] tracking-[0.35em] text-ink/50">
            THE WOMAN WHO:
          </p>
          {traits.map((t, i) => (
            <FadeUp key={t} delay={i * 0.05}>
              <div
                data-testid={`who-for-item-${i + 1}`}
                className="group flex items-baseline gap-6 border-t border-ink/15 py-5 transition-[padding] duration-300 hover:pl-3"
              >
                <span className="font-sans text-[10px] tracking-[0.3em] text-oxblood">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <p className="font-serif text-xl text-ink/85 transition-colors duration-300 group-hover:text-wine md:text-2xl">
                  {t}
                </p>
              </div>
            </FadeUp>
          ))}

          <FadeUp delay={0.3}>
            <blockquote className="mt-14 border-l-2 border-oxblood pl-8">
              <p className="font-serif text-2xl italic leading-snug text-ink md:text-3xl">
                I don't have to know everything. But before I move —{" "}
                <span className="text-wine">I need to know what matters.</span>
              </p>
            </blockquote>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
